import { createContext, useState, useEffect, FC } from 'react';
import { useLocation } from 'react-router';
import API from '../api/api';
import { EQueryStringParam } from '../util/constants';

export enum EChangeEmailStaffUiState {
    default,
    queryStringParsed,
    ready,
    error,
    success,
}

type TChangeEmailStaffContext = {
    changeEmailStaffUiState: EChangeEmailStaffUiState;
    email: string;
    customerAccountName: string;
};

const ChangeEmailStaffContext = createContext<TChangeEmailStaffContext | undefined>(undefined);

export const ChangeEmailStaffProvider: FC = ({ children }) => {
    const [changeEmailStaffUiState, setChangeEmailStaffUiState] = useState(EChangeEmailStaffUiState.default);
    const [email, setEmail] = useState('');
    const [customerAccountName, setCustomerAccountName] = useState('');
    const { search: queryParams } = useLocation();

    const parseQueryString = () => {
        const params = new URLSearchParams(queryParams);
        setCustomerAccountName(params.get(EQueryStringParam.customerAccountName));
        setChangeEmailStaffUiState(EChangeEmailStaffUiState.queryStringParsed);
    };

    const changeEmail = async () => {
        try {
            const response = await API.get.changeStaffEmail(queryParams);
            setEmail(response.data.email);
            setChangeEmailStaffUiState(EChangeEmailStaffUiState.success);
        } catch {
            console.error('Failed to change staff email');
            setChangeEmailStaffUiState(EChangeEmailStaffUiState.error);
        }
    };

    useEffect(() => {
        if (changeEmailStaffUiState === EChangeEmailStaffUiState.default) {
            parseQueryString();
        } else if (changeEmailStaffUiState === EChangeEmailStaffUiState.queryStringParsed) {
            changeEmail();
        }
    }, [changeEmailStaffUiState]);

    return (
        <ChangeEmailStaffContext.Provider value={{ changeEmailStaffUiState, email, customerAccountName }}>
            {children}
        </ChangeEmailStaffContext.Provider>
    );
};

export default ChangeEmailStaffContext;
